
<template>
  <section id="PropertyFacilities" v-show="topAmenitiesList.length">
    <h2 class="text-title-2 fw-semi-bold">{{$t('Facilities')}}</h2>
    <div class="container pt-1">
      <div class="property-amenities">
            <span v-for="amenity in shortTopAmenitiesList" :key="(amenity as any).code" class="amenity">
            <span class="icon" :class="`icon ${amenity.icon} color-blue`"/> {{amenity.name}}
            <!--<span class="icon icon-check color-blue"/> {{amenity.name}} -->
          </span>
      </div>
      <button
          v-if="property.hotel_amenities?.length >= 10"
          aria-label="See more"
          class="btn btn-secondary amenities-more-button"
          @click="isModalVisible = true"
      >
        {{$t('See more')}} <span class="icon icon-chevron-right"></span>
      </button>
    </div>

    <LazyDialogCloseOutside
        v-model="isModalVisible"
        :showHeader="false"
        position="right"
        :block-scroll="true"
        :modal="true"
        :draggable="false"
        class="modal-container custom-scrollbar"
    >
      <div class="dialog-header-wrapper">
        <button class="mobile-only" @click="isModalVisible = false">
          <span class="icon icon-chevron-left color-blue text-title-1"></span>
        </button>
        <span class="flex-1 text-title-1 fw-bold dialog-info-header">{{$t('Facilities')}}</span>
        <button class="desktop-only" @click="isModalVisible = false">
          <span class="icon icon-close color-blue text-title-1"></span>
        </button>
      </div>
      <div class="dialog-body">
        <h2>{{$t('Most popular facilities')}}</h2>
        <div class="property-amenities">
            <span v-for="amenity in shortTopAmenitiesList" :key="(amenity as any).code" class="amenity">
            <span class="icon" :class="`icon ${amenity.icon} color-blue`"/> {{amenity.name}}
          </span>
        </div>
        <h2>{{$t('Other facilities')}}</h2>
        <div class="property-amenities property-amenities--others">
            <span v-for="amenity in notTopAmenities" :key="amenity.ota_code" class="amenity">
             <span class="icon icon-check"/> {{amenity.name}}
          </span>
        </div>
      </div>
    </LazyDialogCloseOutside>
  </section>
</template>

<script setup lang="ts">
import {usePropertyStore} from "~/store/property";
import {TOP_AMENITIES} from "~/utils/hotels";
import DialogCloseOutside from "~/components/DialogCloseOutside.vue";

const property = usePropertyStore().property

const isModalVisible = ref(false)

const topAmenitiesList = computed(() => {
  if (!property?.amenities?.length) {
    return []
  }
  const hotelAmenities = [...property?.amenities?.filter((amenity: any) => amenity.group === 'hotel')]

  return TOP_AMENITIES.filter((amenity: any) => {
    return hotelAmenities?.find((hotelAmenity: any) => hotelAmenity.code === amenity.code) || false
  })

})

const shortTopAmenitiesList = computed(() => {
  return topAmenitiesList?.value?.slice(0, 10) || []
})

const notTopAmenities = computed(() => {
  return property?.amenities?.filter((amenity: any) => !topAmenitiesList?.value?.find((topAmenity: any) => topAmenity.code === amenity.code)) || []
})
</script>


<style scoped lang="scss">
.property-amenities {
  display: flex;
  flex-wrap: wrap;
  column-gap: 24px;
  row-gap: 24px;

  &--others {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px 24px;
  }
  .amenity {
    display: flex;
    font-size: 14px;
    gap: 8px;
    align-items: flex-start;

    @media screen and (max-width: 430px) {
      width: calc(50% - 24px);
      font-weight: 400;
      line-height: 20px;
    }
    .icon {
      padding-top: 2px;
      font-size: 16px;
    }
  }
}

.amenities-more-button {
  white-space: nowrap;
  padding: 10px 20px;
  height: 40px;
  margin-top: 24px;

  //tablet
  @media screen and (max-width: 1024px) and (min-width: 768px){
    white-space: nowrap;
  }

  @media screen and (max-width: 430px) {
    width: 100%;
    align-items: center;
    justify-content: center;
    max-height: 40px;
    margin-top: 20px;
  }

  .icon {
    font-size: 16px;

    @media screen and (max-width: 768px) {
      font-size: 16px;
    }
  }
}

//modal

:global(.modal-container) {
  width: 100%;
  max-width: 708px;
  height: 100%;
  max-height: 100%;
  padding: 24px 32px;
  overflow-y: auto;

  @media screen and (max-width: 768px) {
    padding: 16px;
  }
}



.dialog-header-wrapper {
  display: flex;

  @media screen and (max-width: 768px) {
    align-items: center;
    gap: 24px;
  }
}

.dialog-info-header {
  line-height: 1.1;
  align-items: center;
  display: flex;

  @media screen and (max-width: 768px) {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
  }
}

.dialog-body {
  h2 {
    color: var(--black);
    font-size: 16px;
    font-weight: 600;
    line-height: 150%;
    padding-bottom: 16px;
    padding-top: 24px;
  }
}
</style>
